import { render } from "./teamLessonDetail.vue?vue&type=template&id=e1c79a8e&scoped=true"
import script from "./teamLessonDetail.vue?vue&type=script&lang=js"
export * from "./teamLessonDetail.vue?vue&type=script&lang=js"

import "./teamLessonDetail.vue?vue&type=style&index=0&id=e1c79a8e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1c79a8e"]])

export default __exports__